import { ReactNode, useContext } from 'react';

import { Box, Text } from '../index';
import { atoms } from '../../css/atoms/atoms.css';

import { radioButtonGroupContext } from './lib/context';
import { radioItemContainer, radioButtonStyle, inputRadioStyle } from './RadioButtonGroupItem.css';

type IconPosition = 'leading' | 'trailing';

export interface RadioButtonGroupItemProps {
  value?: string;
  icon?: ReactNode;
  iconPosition?: IconPosition;
  children?: ReactNode;
}

function ButtonText({
  icon,
  iconPosition,
  children,
}: {
  icon?: ReactNode;
  iconPosition?: IconPosition;
  children?: ReactNode;
}) {
  if (icon) {
    return (
      <Text weight="demibold" size="medium">
        {iconPosition === 'leading' && (
          <span
            className={atoms({
              paddingRight: children ? 'xsmall' : 'none',
            })}
          >
            {icon}
          </span>
        )}
        {children}
        {iconPosition === 'trailing' && (
          <span
            className={atoms({
              paddingLeft: children ? 'xsmall' : 'none',
            })}
          >
            {icon}
          </span>
        )}
      </Text>
    );
  }
  return (
    <Text weight="demibold" size="medium">
      {children}
    </Text>
  );
}

export const RadioButtonGroupItem: React.FC<RadioButtonGroupItemProps> = ({
  value,
  icon,
  iconPosition = 'leading',
  children,
}) => {
  const { name, value: selectedValue, onChange } = useContext(radioButtonGroupContext);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!onChange) return;
    const newValue = event.currentTarget.value;
    onChange(newValue);
  };

  return (
    <label className={radioItemContainer}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={selectedValue === value}
        aria-checked={selectedValue === value}
        onChange={handleChange}
        className={inputRadioStyle}
      />
      <Box
        component="span"
        display="block"
        textAlign="center"
        position="relative"
        height="full"
        className={radioButtonStyle}
      >
        {typeof children === 'string' ? (
          <ButtonText icon={icon} iconPosition={iconPosition}>
            {children}
          </ButtonText>
        ) : (
          children
        )}
      </Box>
    </label>
  );
};
